<template>
  <div class="loader-wrapper">
    <slot></slot>
    <div class="loader-content" v-show="loading">
      <moon-loader :loading="loading" color="#37ca37" size="30px"/>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'





export default defineComponent({
  props: [
    'loading'
  ]
});
</script>

<style scoped>
.loader-wrapper {
  display: inline-block;
  position: relative;
}
.loader-content {
  position: absolute;
  top: 21%;
  left: 33%;
}
</style>
